/**
 * WE2 P2-09: WorkspaceReplayTradingContext
 *
 * Holds a SINGLE shared replay-trading session (ReplayOrderBook + analytics)
 * at the VNInvestMultiCharts (parent) level. Per DECISION-1 / H3 (workspace-level,
 * chốt 2026-07-17): paper trade là 1 session chung cho toàn bộ workspace.
 *
 * Chỉ chart ACTIVE mới feed bars vào shared order book (qua `feedBar`), tránh
 * trộn lẫn bars khi các chart có symbol khác nhau. Mọi chart đọc chung
 * `positions` / `closedTrades` từ singleton này.
 */
import { createContext, useContext } from "react";
const defaultValue = undefined;
export const WorkspaceReplayTradingContext = createContext(defaultValue);
export function useWorkspaceReplayTrading() {
    const ctx = useContext(WorkspaceReplayTradingContext);
    if (ctx === defaultValue) {
        throw new Error("useWorkspaceReplayTrading must be used within WorkspaceReplayTradingProvider");
    }
    return ctx;
}
export function useOptionalWorkspaceReplayTrading() {
    const ctx = useContext(WorkspaceReplayTradingContext);
    return ctx === defaultValue ? undefined : ctx;
}
